import { Link } from "@tanstack/react-router";

import { Section } from "@/components/Section";
import { Container } from "@/components/Container";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";
import { NAP } from "@/lib/business";

/**
 * Light local signal near the foot of the homepage: a real address and a real
 * service area, stated once, in prose.
 */
export function LocalPresence() {
  return (
    <Section tone="raised">
      <Container variant="narrow">
        <Reveal>
          <Eyebrow>Where we work</Eyebrow>
          <h2 className="mt-3 font-display text-h2 text-ink-900" style={{ textWrap: "balance" }}>
            AI consulting in Las Vegas, and everywhere else.
          </h2>
          <div className="mt-5 max-w-[68ch] space-y-4 text-body-lg text-ink-600">
            <p>
              We work out of {NAP.street} in downtown {NAP.city}. For businesses in the valley —
              Henderson, North Las Vegas, Summerlin — that usually means sitting with your team
              while they work, which is the fastest way to see where the time actually goes.
            </p>
            <p>
              Everywhere else, the same work happens remotely, and most of our engagements always
              did.{" "}
              <Link
                to="/contact"
                className="text-brand-700 underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700"
              >
                Tell us what you are trying to fix
              </Link>
              , or{" "}
              <Link
                to="/book"
                className="text-brand-700 underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700"
              >
                book a free AI call
              </Link>
              .
            </p>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}

export default LocalPresence;
